import { useSelector } from 'react-redux';
import { getUnifiedPublishType } from '../../../redux/selectors/publishSelectors';
// @ts-expect-error Untyped module
import WarningsAndSuggestionsPanel from '../../modals/WarningsAndSuggestionsPanel';
import UnpublishConfirmModal from '../../modals/UnpublishConfirmModal';
import BaseSchedulingOptionsModal from '../../publishing/modals/BaseSchedulingOptionsModal';
import CancelScheduleConfirmModal from '../../publishing/modals/schedulingOptions/CancelScheduleConfirmModal';
import PatagoniaBasePublishConfirmModal from '../../publishing/modals/PatagoniaBasePublishConfirmModal';
import { PublishActionModalNames } from '../../publishing/types/publishButtonTypes';
import useContentCrmObject from '../hooks/useContentCrmObject';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorPublishButtonActionModals = ({
  publishErrors,
  publishWarnings,
  onIssueClick,
  buttonTextKey,
  schedulingOptionsModalProps = {},
  setCancelScheduleModalType,
  contentTypeHasSavedViews,
  cancelScheduleModalType,
  publishConfirmModalBodyContent,
  publishConfirmDisabled,
  publishConfirmDisabledTooltip,
  publish,
  unpublish,
  schedulePublishUnpublish,
  openModalName,
  openModal,
  closeModal
}) => {
  const {
    contentCrmObjectPublishType
  } = useContentCrmObject();
  const unifiedPublishType = useSelector(getUnifiedPublishType);
  switch (openModalName) {
    case PublishActionModalNames.PUBLISH_CONFIRM:
      return /*#__PURE__*/_jsx(PatagoniaBasePublishConfirmModal, {
        afterCloseCallback: closeModal,
        secondaryCallback: closeModal,
        primaryButtonKey: buttonTextKey,
        headerLangKey: `publishConfirmModal.header.${contentCrmObjectPublishType || unifiedPublishType}`,
        secondaryButtonKey: "publishConfirmModal.footer.cancel",
        primaryButtonDisabled: publishConfirmDisabled,
        primaryButtonDisabledTooltip: publishConfirmDisabledTooltip,
        primaryCallback: () => {
          publish(contentCrmObjectPublishType || unifiedPublishType);
          closeModal();
        },
        children: publishConfirmModalBodyContent
      });
    case PublishActionModalNames.UNPUBLISH_CONFIRM:
      return /*#__PURE__*/_jsx(UnpublishConfirmModal, {
        onClose: closeModal,
        unpublish: unpublish
      });
    case PublishActionModalNames.SCHEDULING_OPTIONS:
      return /*#__PURE__*/_jsx(BaseSchedulingOptionsModal, Object.assign({}, schedulingOptionsModalProps, {
        publish: publish,
        schedulePublishUnpublish: schedulePublishUnpublish,
        closeModal: closeModal,
        openCancelScheduleConfirmModal: modalType => {
          setCancelScheduleModalType(modalType);
          openModal(PublishActionModalNames.CANCEL_SCHEDULE);
        },
        contentTypeHasSavedViews: contentTypeHasSavedViews
      }));
    case PublishActionModalNames.CANCEL_SCHEDULE:
      return /*#__PURE__*/_jsx(CancelScheduleConfirmModal, {
        closeModal: closeModal,
        actionTypeBodyInfoKey: cancelScheduleModalType,
        isScheduleUpdate: false,
        publish: publish
      });
    case PublishActionModalNames.WARNINGS_AND_SUGGESTIONS:
      return /*#__PURE__*/_jsx(WarningsAndSuggestionsPanel, {
        errorLabels: publishErrors,
        warningLabels: publishWarnings,
        onClose: closeModal,
        onIssueClick: onIssueClick
      });
    default:
      return null;
  }
};
export default EditorPublishButtonActionModals;